export default __webpack_public_path__ + "static/qt-sweetcombe-marque-5-star-silver-rgb-806d633f988ee232f916ef5711d36061.png";